import axios from "../axios-auth";

export const saleReturnService = {
  getSaleList,
};

function getSaleList(searchParams) {
    let params = {};

  if (searchParams.saleNo) {
    params["saleNo"] = searchParams.saleNo;
  }

  return axios.get("/auth/sale-return", { params });
}

